<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Master Benefit Category</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Category</b>
      <br />
      <b-row class="mt-4">
        <b-col>
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Category English"
            label-for="input-1"
          >
            <input
              id="input-1"
              placeholder="Category English"
              v-validate="'required'"
              v-model="display"
              data-vv-as="Category English"
              name="display"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-display-feedback">{{ veeErrors.first('display') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Category Bahasa"
            label-for="input-1"
          >
            <input
              id="input-1"
              placeholder="Category Bahasa"
              v-validate="'required'"
              v-model="display_id"
              data-vv-as="Category Bahasa"
              name="display_id"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-display_id-feedback">{{ veeErrors.first('display_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <div class="form-group required font-weight-bold">
        <label class="control-label"></label>
        Required
      </div>
      <b-row class="text-right">
        <b-col>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="mr-3"
            size="lg"
          >Create</b-button>
          <router-link :to="{name: 'BenefitCategory'}">
            <b-button variant="outline-secondary" size="lg">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      display: "",
      display_id: "",
    };
  },
  methods: {
    post() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("display", this.display);
          formData.append("display_id", this.display_id);
          this.$store
            .dispatch("BenefitCategoryModule/postBenefitCategory", formData)
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "BenefitCategory" });
              this.$swal({
                type: "success",
                title: "Your data has been saved",
                showConfirmButton: false,
                timer: 1500
              });
            })
            .catch(error => {
              this.loading = false;
              this.serverError = error.response.data;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500
              });
              console.log(error);
            });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    }
  }
};
</script>

<style>
</style>
